export default __webpack_public_path__ + "b648fb20c8f90b6943b77634a47dec7e.png";